export function DisplaySmall({children, color, fontWeight = 600, textAlign='justify'}) {
    return (
        <span style={{
            textAlign,
            lineHeight: '1.1em',
            fontFamily: 'Open Sans',
            fontSize: '2.25em',
            color,
            fontWeight,
        }}>{children}</span>
    );
}
